import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconRadioButtonStyle0 = cosmosIconCss;

const CosmosIconRadioButton$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRadioButton extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ad497e5a7b208089c543c73a76b04957e155bb1b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c9ab5aa1cad45db16867ab0c2d7ee9274a08920b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b06132ab24d7f67fad54d9f1577e6db3a09671c3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15ZM11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconRadioButtonStyle0; }
}, [1, "cosmos-icon-radio-button", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-radio-button"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-radio-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRadioButton$1);
            }
            break;
    } });
}

const CosmosIconRadioButton = CosmosIconRadioButton$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRadioButton, defineCustomElement };
